<template>
  <div class="container">
    <content-title :nav="nav"></content-title>

    <!-- 统计卡片区域 -->
    <div class="statistics-cards">
      <div class="stat-card" v-for="(item, index) in statisticsCards" :key="index">
        <div class="card-icon" :style="{ backgroundColor: item.color }">
          <i :class="item.icon"></i>
        </div>
        <div class="card-content">
          <p class="card-label">{{ item.label }}</p>
          <p class="card-value">¥ {{ formatMoney(item.value) }}</p>
        </div>
      </div>
    </div>

    <!-- 时间段筛选 -->
    <div class="filter-section">
      <el-form :inline="true" class="demo-form-inline">
        <el-form-item label="时间范围">
          <el-date-picker
            v-model="dateRange"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            @change="handleDateChange"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="status" placeholder="请选择状态" clearable style="width: 150px">
            <el-option label="未结算" :value="1"></el-option>
            <el-option label="已结算" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="queryRangeStatistics">查询</el-button>
          <el-button @click="resetFilter">重置</el-button>
          <el-button 
            v-if="rangeData.incomeAmount !== null && canSettle" 
            type="success" 
            @click="handleSettle" 
            icon="el-icon-wallet"
          >结算收益</el-button>
          <el-button type="success" @click="exportData" icon="el-icon-download">导出数据</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!-- 时间段统计结果 -->
    <div class="range-statistics" v-if="rangeData.incomeAmount !== null">
      <el-row :gutter="24">
        <el-col :span="6">
          <div class="range-card income">
            <p class="range-label">总收入</p>
            <p class="range-value">¥ {{ formatMoney(rangeData.incomeAmount) }}</p>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="range-card expense">
            <p class="range-label">总扣除</p>
            <p class="range-value">¥ {{ formatMoney(rangeData.expenseAmount) }}</p>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="range-card net">
            <p class="range-label">净收益</p>
            <p class="range-value">¥ {{ formatMoney(rangeData.netAmount) }}</p>
          </div>
        </el-col>
         <el-col :span="6">
          <div class="range-card net">
            <p class="range-label">已结算金额</p>
            <p class="range-value">¥ {{ formatMoney(rangeData.settledNetAmount) }}</p>
          </div>
        </el-col>

        
      </el-row>
    </div>

    <!-- 业绩记录列表 -->
    <div class="table-section">
      <auto-table
        :DataList="DataList"
        :option="tableColumns"
        :total="Total"
        :loading="is_loading"
        @changePage="changeCurrentPage"
      >
        <template #type="{ row }">
          <el-tag v-if="row.type === 1" type="success" size="small">
            收入
          </el-tag>
            <el-tag v-if="row.type === 2" type="info" size="small">
            扣除
          </el-tag>
           <el-tag v-if="row.type === 3" type="primary" size="small">
            结算
          </el-tag>

        </template>
        <template #status="{ row }">
          <el-tag :type="getStatusType(row.status)" size="small">
            {{ getStatusLabel(row.status) }}
          </el-tag>
        </template>
        <template #amount="{ row }">
          <span :class="row.type === 1 ? 'income-text' : 'expense-text'">
            {{ row.type === 1 ? '+' : '-' }} ¥ {{ formatMoney(row.amount) }}
          </span>
        </template>
        <template #create_time="{ row }">
          {{ row.create_time | formatDate }}
        </template>
      </auto-table>
    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {
      nav: { firstNav: "教练管理", secondNav: "教练业绩统计", url: "" },
      
      // 统计数据
      statisticsData: {
        todayPerformance: 0,
        monthPerformance: 0,
        pendingSettlement: 0,
        totalIncome: 0,
        totalExpense: 0
      },
      
      // 时间段统计数据
      rangeData: {
        incomeAmount: null,
        expenseAmount: null,
        netAmount: null
      },
      
      // 筛选条件
      coach_id: '',
      dateRange: [],
      start_time: '',
      end_time: '',
      status: null, // 状态筛选：1未结算 2已结算
      
      // 列表数据
      DataList: [],
      is_loading: true,
      currentPage: 1,
      Total: 0,
      pageSize: 10,
      
      // 表格列配置
      tableColumns: [
        { name: '订单号', value: 'flow_no' },
        { name: '课程名称', value: 'title' },
        { name: '类型', value: 'type', type: 'custom' },
        { name: '金额', value: 'amount',type: 'custom' },
        { name: '状态', value: 'status',  type: 'custom' },
        { name: '创建时间', value: 'create_time', width: '180', type: 'custom' }
      ]
    };
  },
  
  computed: {
    // 统计卡片数据
    statisticsCards() {
      return [
        {
          label: '今日业绩',
          value: this.statisticsData.todayPerformance,
          icon: 'el-icon-date',
          color: '#409EFF'
        },
        {
          label: '本月业绩',
          value: this.statisticsData.monthPerformance,
          icon: 'el-icon-money',
          color: '#67C23A'
        },
        {
          label: '可结算业绩',
          value: this.statisticsData.pendingSettlement,
          icon: 'el-icon-wallet',
          color: '#E6A23C'
        },
        // {
        //   label: '总收入',
        //   value: this.statisticsData.totalIncome,
        //   icon: 'el-icon-money',
        //   color: '#F56C6C'
        // },
        // {
        //   label: '总支出',
        //   value: this.statisticsData.totalExpense,
        //   icon: 'el-icon-sell',
        //   color: '#909399'
        // }
      ];
    },
    canSettle() {
      // 只有查询了时间段数据，且有净收益时才允许结算
      return this.rangeData.incomeAmount !== null && 
             this.rangeData.netAmount > 0;
    }
  },
  
  watch: {
    // 监听教练ID变化，自动刷新数据
    coach_id(newVal) {
      if (newVal) {
        this.getStatistics();
        this.currentPage = 1;
        this.getList();
      }
    }
  },
  
  filters: {
    formatDate(value) {
      if (!value) return '';
      const date = new Date(value);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const hour = String(date.getHours()).padStart(2, '0');
      const minute = String(date.getMinutes()).padStart(2, '0');
      const second = String(date.getSeconds()).padStart(2, '0');
      return `${year}-${month}-${day} ${hour}:${minute}:${second}`;
    }
  },
  
  mounted() {
    // 从路由参数中获取教练ID
    if (this.$route.query.coach_id) {
      this.coach_id = this.$route.query.coach_id;
    }
    this.getStatistics();
    this.getList();
  },
  
  methods: {
    // 获取统计数据
    getStatistics() {
      const url = '/user/coachPerformanceRecord/statistics';
      const params = {};
      if (this.coach_id) {
        params.coach_id = this.coach_id;
      }
      
      this.$axios.get(url, { params }).then((res) => {
        this.statisticsData = res.data.data || {};
      }).catch(() => {
        this.statisticsData = {
          todayPerformance: 0,
          monthPerformance: 0,
          pendingSettlement: 0,
          totalIncome: 0,
          totalExpense: 0
        };
      });
    },
    
    // 获取时间段统计数据
    queryRangeStatistics() {
      if (!this.start_time || !this.end_time) {
        this.$message.warning('请选择时间范围');
        return;
      }
      
      const loading = this.$loading({
        lock: true,
        text: '查询中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      
      const url = '/user/coachPerformanceRecord/statistics/range';
      const params = {
        start_time: this.start_time,
        end_time: this.end_time
      };
      if (this.coach_id) {
        params.coach_id = this.coach_id;
      }
      
      this.$axios.get(url, { params }).then((res) => {
        this.rangeData = res.data.data || {};
        this.$message.success('查询成功');
        loading.close();
      }).catch(() => {
        this.$message.error('查询失败');
        loading.close();
      });

      this.getList()
    },
    
    // 结算收益
    handleSettle() {
      if (!this.coach_id) {
        this.$message.warning('请先选择教练');
        return;
      }
      
      if (!this.start_time || !this.end_time) {
        this.$message.warning('请先查询时间段数据');
        return;
      }
      
      if (this.rangeData.netAmount <= 0) {
        this.$message.warning('当前时间段无可结算收益');
        return;
      }
      
      this.$confirm(
        `确认结算该时间段内的收益？\n总收入：¥${this.formatMoney(this.rangeData.incomeAmount)}\n总扣除：¥${this.formatMoney(this.rangeData.expenseAmount)}\n净收益：¥${this.formatMoney(this.rangeData.netAmount)}`,
        '结算确认',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      ).then(() => {
        const loading = this.$loading({
          lock: true,
          text: '结算中...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        
        const url = '/user/coachPerformanceRecord/settle';
        const data = {
          coach_id: this.coach_id,
          start_time: this.start_time,
          end_time: this.end_time
        };
        
        this.$axios.post(url, data).then((res) => {
          loading.close();
          if (res.data.code === 0) {
            this.$message.success('结算成功');
            // 刷新统计数据和列表
            this.getStatistics();
            this.getList();
            // 清空时间段统计，避免重复结算
            this.rangeData = {
              incomeAmount: null,
              expenseAmount: null,
              netAmount: null
            };
          } else {
            this.$message.error(res.data.message || '结算失败');
          }
        }).catch(() => {
          loading.close();
          this.$message.error('结算失败');
        });
      }).catch(() => {
        // 用户取消操作
      });
    },
    
    // 重置筛选
    resetFilter() {
      this.dateRange = [];
      this.start_time = '';
      this.end_time = '';
      this.status = null;
      this.rangeData = {
        incomeAmount: null,
        expenseAmount: null,
        netAmount: null
      };
      this.currentPage = 1
      this.getList();
    },
    
    // 导出数据
    exportData() {
      if (this.DataList.length === 0) {
        this.$message.warning('暂无数据可导出');
        return;
      }
      
      // 构建导出数据
      const exportData = this.DataList.map(item => ({
        '订单号': item.flow_no,
        '课程名称': item.title,
        '类型': item.type === 1 ? '收入' : (item.type === 2 ? '扣除' : '结算'),
        '金额': item.amount,
        '状态': this.getStatusLabel(item.status),
        '创建时间': this.$options.filters.formatDate(item.create_time)
      }));
      
      // 使用 CSV 导出
      this.exportToCSV(exportData, `教练业绩统计_${new Date().getTime()}`);
    },
    
    // 获取列表数据
    getList() {
      this.is_loading = true;
      const url = '/user/coachPerformanceRecord/queryManagerListPage';
      const params = {
        page: this.currentPage,
        page_size: this.pageSize
      };
      
      if (this.coach_id) {
        params.coach_id = this.coach_id;
      }
      
      // 添加时间段筛选
      if (this.start_time && this.end_time) {
        params.start_time = this.start_time;
        params.end_time = this.end_time;
      }
      
      // 添加状态筛选
      if (this.status) {
        params.status = this.status;
      }
      
      this.$axios.get(url, { params }).then((res) => {
        this.DataList = res.data.data.rows || [];
        this.Total = res.data.data.total || 0;
        this.is_loading = false;
      }).catch(() => {
        this.is_loading = false;
        this.$message.error('获取列表失败');
      });
    },
    
    // 切换分页
    changeCurrentPage(page) {
      this.currentPage = page;
      this.getList();
    },
    
    // 格式化金额
    formatMoney(value) {
      if (value === null || value === undefined) {
        return '0.00';
      }
      return parseFloat(value).toFixed(2);
    },
    
    // 获取状态标签
    getStatusLabel(status) {
      const statusMap = {
        1: '未结算',
        2: '已结算'
      };
      return statusMap[status] || '未知';
    },
    
    // 获取状态类型
    getStatusType(status) {
      const typeMap = {
        1: 'warning',
        2: 'success'
      };
      return typeMap[status] || 'info';
    },
    
    // 日期范围改变
    handleDateChange(val) {
      if (val && val.length === 2) {
        this.start_time = val[0] + ' 00:00:00';
        this.end_time = val[1] + ' 23:59:59';
      } else {
        this.start_time = '';
        this.end_time = '';
      }
    },
    
    // CSV 导出工具方法
    exportToCSV(data, filename) {
      if (!data || data.length === 0) {
        this.$message.warning('没有数据可导出');
        return;
      }
      
      // 获取表头
      const headers = Object.keys(data[0]);
      const csvContent = [
        headers.join(','), // 表头
        ...data.map(row => 
          headers.map(header => {
            const value = row[header];
            // 如果值包含逗号或换行符，需要用引号包裹
            if (typeof value === 'string' && (value.includes(',') || value.includes('\n'))) {
              return `"${value.replace(/"/g, '""')}"`;
            }
            return value;
          }).join(',')
        )
      ].join('\n');
      
      // 添加 BOM 以支持中文
      const blob = new Blob(['\ufeff' + csvContent], { type: 'text/csv;charset=utf-8;' });
      const link = document.createElement('a');
      const url = URL.createObjectURL(blob);
      
      link.setAttribute('href', url);
      link.setAttribute('download', `${filename}.csv`);
      link.style.visibility = 'hidden';
      
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      
      this.$message.success('导出成功');
    }
  }
};
</script>

<style lang="less" scoped>
.container {
  padding: 20px;
}

// 统计卡片区域
.statistics-cards {
  display: flex;
  gap: 20px;
  margin-bottom: 20px;
  flex-wrap: wrap;
}

.stat-card {
  flex: 1;
  min-width: 200px;
  background: #fff;
  border-radius: 8px;
  padding: 20px;
  display: flex;
  align-items: center;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  transition: all 0.3s;
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 16px 0 rgba(0, 0, 0, 0.15);
  }
  
  .card-icon {
    width: 60px;
    height: 60px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 15px;
    
    i {
      font-size: 28px;
      color: #fff;
    }
  }
  
  .card-content {
    flex: 1;
    
    .card-label {
      font-size: 14px;
      color: #909399;
      margin-bottom: 8px;
    }
    
    .card-value {
      font-size: 24px;
      font-weight: bold;
      color: #303133;
    }
  }
}

// 筛选区域
.filter-section {
  background: #fff;
  padding: 20px;
  border-radius: 8px;
  margin-bottom: 20px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

// 时间段统计
.range-statistics {
  margin-bottom: 20px;
  
  .range-card {
    padding: 20px;
    border-radius: 8px;
    text-align: center;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    
    &.income {
      background: linear-gradient(135deg, #67C23A 0%, #85CE61 100%);
      color: #fff;
    }
    
    &.expense {
      background: linear-gradient(135deg, #F56C6C 0%, #F78989 100%);
      color: #fff;
    }
    
    &.net {
      background: linear-gradient(135deg, #409EFF 0%, #66B1FF 100%);
      color: #fff;
    }
    
    .range-label {
      font-size: 16px;
      margin-bottom: 10px;
      opacity: 0.9;
    }
    
    .range-value {
      font-size: 28px;
      font-weight: bold;
    }
  }
}

// 表格区域
.table-section {
  background: #fff;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

// 金额颜色
.income-text {
  color: #67C23A;
  font-weight: bold;
}

.expense-text {
  color: #F56C6C;
  font-weight: bold;
}
</style>
